import React, { Component, Fragment } from 'react';
import ReactQuill from 'react-quill';

import { I18n } from 'components/translate';
import { QuizService } from 'modules/content/quiz';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './EditorComponent.scss';

class ProfileEditorComponent extends Component {
  static propTypes = {
    content: PropTypes.string,
    formats: PropTypes.array,
    modules: PropTypes.array,
    profileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    charLimit: PropTypes.number,
    updateCharCount: PropTypes.func,
    charCount: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
      charLimit: props.charLimit,
      charCount: 0
    };
  }

  handleOnChange = (content, delta, source, editor) => {
    if (editor.getLength() > this.state.charLimit + 1 && this.reactQuillRef) {
      UiService.setAlertError(`quiz.profile_${this.props.type}_limit`, {
        limit: this.state.charLimit
      });
      const editor2 = this.reactQuillRef.getEditor();
      let delta2 = editor2.getContents();

      delta2 = delta2.slice(0, this.state.charLimit);
      editor2.setContents(delta2);
      this.reactQuillRef.focus();
    } else {
      this.setState({ content });
      QuizService.updateProfileContent(
        this.props.profileId,
        this.props.type,
        content
      );
    }
    this.setState({ charCount: editor.getLength() - 1 });
  };

  handleOnBlur = () => {
    QuizService.updateProfileContent(
      this.props.profileId,
      this.props.type,
      this.state.content
    );
  };

  componentDidMount() {
    if (this.reactQuillRef && this.props.type === 'name') {
      this.reactQuillRef.focus();
    }
  }

  get modules() {
    return (
      this.props.modules || {
        toolbar: [['bold', 'italic', 'link']],
        keyboard: {
          bindings: {
            tab: 'disabled'
          }
        }
      }
    );
  }

  get formats() {
    return this.props.formats || ['bold', 'italic', 'link'];
  }

  checkLength = () => {
    const { charLimit, charCount } = this.state;

    let initialLenth = 0;

    if (this.reactQuillRef && charLimit && charCount === 0) {
      const editor = this.reactQuillRef.getEditor();

      initialLenth = editor.getLength() - 1;
    }

    return initialLenth;
  };

  renderEditor = () => {
    const { className, placeholder, readOnly, profileId, type } = this.props;

    return (
      <ReactQuill
        value={this.state.content || this.props.content}
        theme="bubble"
        formats={this.formats}
        modules={this.modules}
        id={`${type}-${profileId}`}
        placeholder={placeholder || ''}
        readOnly={readOnly === true}
        className={`${className} rc-editor-wrapper`}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        bounds="#questionsContent"
        name={`${type}-${profileId}`}
        ref={(el) => (this.reactQuillRef = el)}
      />
    );
  };

  render() {
    const initialLenth = this.checkLength();

    return (
      <Fragment>
        {this.renderEditor()}
        <div className="char__limit">
          {this.state.charLimit - (this.state.charCount || initialLenth)}{' '}
          <I18n label="general.characters" />
        </div>
      </Fragment>
    );
  }
}

export default ProfileEditorComponent;
